import { useApi } from '@/api';
import { CardList, Link, LinkButton, ListSkeleton } from '@/components';
import {
  CurrencyValue,
  Flex,
  ListItem,
  WalletAddress
} from '@blockanalitica/ui';

export default function TopDepositors({ ...rest }) {
  const [data, error] = useApi({
    url: '/save/dsr/depositors/',
    queryParams: {
      p_size: '3',
      order: '-total_balance'
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <CardList
        title="Top Suppliers"
        action={
          <LinkButton to="suppliers" variant="secondary">
            view all
          </LinkButton>
        }
        {...rest}>
        {data['results'].length > 0 &&
          data['results'].map((row) => (
            <ListItem
              variant="link"
              // @ts-ignore
              as={Link}
              key={row.wallet_address}
              to={`suppliers/${row.wallet_address}`}>
              <Flex justifyContent="space-between" alignItems="center">
                <WalletAddress address={row.wallet_address} />
                <CurrencyValue
                  value={row.total_balance}
                  options={{
                    currency: {
                      name: 'DAI',
                      address: data.dai_address
                    },
                    iconSize: '0'
                  }}
                />
              </Flex>
            </ListItem>
          ))}
      </CardList>
    );
  }

  return <ListSkeleton {...rest} />;
}
